<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else-if="product">
            <ValidationObserver ref="productform">
                <form @submit.prevent="saveProduct">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-6">
                                    <ValidationProvider vid="ProdCatID" name="Kategori" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Kategori</label>
                                            <category-filter
                                                v-model="product.ProdCatID"
                                                placeholder="-- Välj kategori --"
                                                :reduce="opt => opt.id"
                                            ></category-filter>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6">
                                    <ValidationProvider vid="ProdSubCatID" name="Underkategori" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Underkategori</label>
                                            <category-sub-filter
                                                v-model="product.ProdSubCatID"
                                                placeholder="-- Välj underkategori --"
                                                :reduce="opt => opt.id"
                                                :category-id="product.ProdCatID"
                                            ></category-sub-filter>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <limitless-tabs
                                :tabs="[{ label: 'Svenska' }]"
                                class="mb-3"
                            >
                                <template #tab-1>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <ValidationProvider vid="ProdNameWeb" name="Namn (Web)" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Namn (Web) <span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" v-model="product.ProdNameWeb" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <ValidationProvider vid="ProdDesc" name="Beskrivning" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Beskrivning</label>
                                            <simple-text-editor
                                                v-model="product.ProdDesc"
                                                :toolbar="[
                                                    'bold',
                                                    'italic',
                                                    'strike',
                                                    'underline',
                                                    'rawmode',
                                                ]"
                                            ></simple-text-editor>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                    <div>
                                        <label>Kvantitet / Variant Web</label>
                                        <div class="row">
                                            <div class="col-lg-2">
                                                <ValidationProvider vid="ProdQty" name="Kvantitet" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="product.ProdQty" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                            <div class="col-lg-4">
                                                <ValidationProvider vid="ProdVariant" name="Variant" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="product.ProdVariant" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </limitless-tabs>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Visa som nyhet t.o.m.</label>
                                        <ValidationProvider tag="div" class="flex-grow-1" vid="new_until" name="Ny t.o.m." v-slot="{ errors }">
                                            <v-date-picker v-model="product.new_until" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                <template v-slot="{ inputValue, togglePopover }">
                                                    <div class="input-group">
                                                        <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{ 'border-danger': !!(errors[0]) }">
                                                        <span class="input-group-append">
                                                            <button class="btn btn-light" type="button" @click="product.new_until = ''"><i class="icon-cross3"></i></button>
                                                        </span>
                                                    </div>
                                                </template>
                                            </v-date-picker>
                                            <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Visa i kategorin "populära produkter"</label>
                                        <ValidationProvider tag="div" class="flex-grow-1" vid="is_popular" name="Är populär" v-slot="{ errors }">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="chk-is_popular" v-model="product.is_popular" :true-value="1" :false-value="0">
                                                <label class="custom-control-label" for="chk-is_popular">Är populär</label>
                                            </div>
                                            <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <limitless-tabs
                                :tabs="language_tabs"
                                class="mb-3"
                            >
                                <template v-for="lang in language_tabs" v-slot:[lang.slot]>
                                    <div :key="'tab-' + lang.id">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <ValidationProvider :vid="'translations.' + lang.id + '.ProdNameWebLang'" name="Namn (Web)" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <label>Namn (Web)</label>
                                                        <input type="text" class="form-control" v-model="product.translations[lang.id].ProdNameWebLang" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <ValidationProvider :vid="'translations.' + lang.id + '.ProdDescLang'" name="Beskrivning" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label>Beskrivning</label>
                                                <simple-text-editor
                                                    v-model="product.translations[lang.id].ProdDescLang"
                                                    :toolbar="[
                                                        'bold',
                                                        'italic',
                                                        'strike',
                                                        'underline',
                                                        'rawmode',
                                                    ]"
                                                ></simple-text-editor>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <div>
                                            <label>Kvantitet / Variant Web</label>
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" :value="product.ProdQty" disabled>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <ValidationProvider :vid="'translations.' + lang.id + '.ProdVariantLang'" name="Variant" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control" v-model="product.translations[lang.id].ProdVariantLang" v-bind:class="{ 'border-danger':errors[0] }">
                                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-lg-6 text-right">
                                                    <limitless-button :ref="'btntranslate' + lang.id.toLowerCase()" type="button" class="btn" btn-class="btn-light" @click="translateTexts(lang.id)" :busy="busy_translating" :saved-text="'Översatt!'">
                                                        <i class="icon-magic-wand mr-2"></i>Översätt (med AI)
                                                    </limitless-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </limitless-tabs>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="card-header bg-light">
                                    <h6 class="card-title">Ikoner</h6>
                                </div>
                                <div class="card-body pb-0">
                                    <div v-for="(icons, header) in grouped_icons" :key="'icons-' + header">
                                        <h4>{{ header }}</h4>
                                        <div class="prod-icons-grid mb-3">
                                            <div v-for="icon in icons" :key="'icon-' + icon.IconTag" class="prod-icon">
                                                <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" class="custom-control-input" :id="'icon-' + icon.IconTag" :value="icon.IconID" v-model="product.icon_ids">
                                                    <label class="custom-control-label" :for="'icon-' + icon.IconTag">
                                                        <span class="inner">
                                                            <span class="icon" :style="{ 'background-image': 'url(' + icon.Url + ')' }"></span>
                                                            {{ icon.IconText }}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-2">
                            <ValidationProvider vid="PackSortNo" name="Sortering" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Sortering</label>
                                    <input type="text" class="form-control" v-model="product.PackSortNo" v-bind:class="{ 'border-danger':errors[0] }">
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsaveproduct" type="button" @click="saveProduct" :busy="busy" icon="icon-floppy-disk">SPARA</limitless-button>
            </div>
        </div>
        <div v-else class="text-danger">Kunde ej hämta data...</div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import CategoryFilter from '@components/Filters/CategoryFilter';
import CategorySubFilter from '@components/Filters/CategorySubFilter';
import getError from '@services/ErrorHelper';
import IconRepository from '@services/repositories/Product/IconRepository';
import SimpleTextEditor from '@components/SimpleTextEditor';
import { groupBy } from 'lodash';
import LimitlessTabs from '@components/Limitless/LimitlessTabs';
import BackendRepository from '@services/repositories/BackendRepository';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';

export default {
    name: 'ProductEditorWeb',
    components: {
        VDatePicker,
        LimitlessTabs,
        SimpleTextEditor,
        LimitlessButton,
        CategoryFilter,
        CategorySubFilter,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy: true,
        busy_translating: false,
        product: null,
        icons: [],
        languages: [],
    }),
    mounted() {
        this.getIcons();
        this.getLanguages();
        this.getProduct();
    },
    watch: {
        'product.ProdCatID': function watchProductProdCatId(newVal, oldVal) {
            if (oldVal !== undefined) {
                this.product.ProdSubCatID = null;
            }
        },
    },
    methods: {
        groupBy,
        getProduct() {
            apiClient.get('/vue/products/' + this.id + '/web')
                .then((response) => {
                    this.product = response.data.product;
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
        async saveProduct() {
            const isValid = await this.$refs.productform.validate();
            if (isValid) {
                this.busy = true;
                await apiClient.post('/vue/products/' + this.id + '/web', this.product)
                    .then((response) => {
                        this.product = response.data.product;
                        this.$refs.btnsaveproduct.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.productform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveproduct.triggerFailed();
                    })
                    .finally(() => {
                        this.busy = false;
                    });
            }
        },
        async getIcons() {
            const client = new IconRepository();
            this.icons = await client.getAll();
        },
        getLanguages() {
            BackendRepository.getLanguages().then((res) => {
                this.languages = res;
            });
        },
        async translateTexts(lang) {
            this.busy_translating = true;
            const postData = {
                from: 'sv',
                to: lang.toLowerCase(),
                json: {
                    ProdNameWeb: this.product.ProdNameWeb,
                    ProdDesc: this.product.ProdDesc,
                    ProdVariant: this.product.ProdVariant,
                },
                options: {
                    tag_handling: 'html',
                },
            };
            await apiClient.post('/vue/translate/openai', postData)
                .then((response) => {
                    this.product.translations[lang].ProdNameWebLang = response.data.result.ProdNameWeb;
                    this.product.translations[lang].ProdDescLang = response.data.result.ProdDesc;
                    this.product.translations[lang].ProdVariantLang = response.data.result.ProdVariant;
                    this.$refs['btntranslate' + lang.toLowerCase()][0].triggerSaved();
                })
                .catch(() => {
                    this.$refs['btntranslate' + lang.toLowerCase()][0].triggerFailed();
                })
                .finally(() => {
                    this.busy_translating = false;
                });
        },
    },
    computed: {
        grouped_icons() {
            return groupBy(this.icons, 'Category');
        },
        language_tabs() {
            if (!this.product) {
                return [];
            }
            return this.languages.filter((lang) => lang.short !== 'SV' && lang.short !== 'SE').map((lang) => {
                let icon = null;
                if (!(this.product.translations[lang.short] && this.product.translations[lang.short].ProdNameWebLang)) {
                    icon = 'icon-warning';
                }
                return {
                    id: lang.short,
                    label: lang.name,
                    slot: 'slot-' + lang.short,
                    icon_after: icon,
                };
            });
        },
    },
};

</script>

<style scoped>
.prod-icons-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.prod-icons-grid .prod-icon {
    margin: 0 5px 5px 0;
}
.prod-icons-grid .prod-icon  .custom-control-label {
    width: 120px;
    height: 130px;
    margin: 0;
    padding: 10px 10px 20px 10px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-radius: 4px;
}
.prod-icons-grid .prod-icon  .custom-control-label .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
.prod-icons-grid .prod-icon  .custom-control-label .inner .icon {
    display: block;
    width: 100%;
    height: 43px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}
.prod-icons-grid .prod-icon  .custom-control-label:before {
    top: auto;
    bottom: 10px;
    left: calc(50% - 10px);
}
.prod-icons-grid .prod-icon  .custom-control-label:after {
    top: auto;
    bottom: 10px;
    left: calc(50% - 10px);
}
.prod-icons-grid .custom-checkbox .custom-control-input:checked ~ .custom-control-label {
    background-color: #e9f5fe;
}
</style>
